import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    maxHeight: 650,
    overflow: 'auto',
    width: '100%',
  },
}));
